import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from '@Sage/hoi-poi-ui';
import { BILLBOARD } from 'constants/Entities';
import { CrudActions } from 'actions';
import useDrawerWidth from 'hooks/useDrawerWidth';

import Content from './Content';
import CrudPreview from './Preview';
import Feedback from './Feedback';
import Header from './Header';

const CrudContainer = memo(() => {
    const dispatch = useDispatch();

    const show = useSelector((state) => state.crud.show);
    const entityType = useSelector((state) => state.crud.entityType);
    const crudError = useSelector((state) => state.crud.errorsCrud.size > 0);
    const showPreview = useSelector((state) => state.crud.showPreview);

    const drawerWidth = useDrawerWidth({ entityType, isOpen: show });

    const feedbackClasses = entityType === BILLBOARD ? ['white'] : [];

    const handleClose = useCallback(() => {
        dispatch(CrudActions.cancelCrud());
    }, [dispatch]);

    const renderContent = show ? <Content /> : null;

    return (
        <div>
            <Drawer isOpen={show} onRequestClose={handleClose} side="right" width={drawerWidth}>
                <div className="react-crud">
                    <Header entityType={entityType} />
                    <div className="react-crud-body">
                        {crudError && <Feedback feedbackClasses={feedbackClasses} />}
                        {renderContent}
                    </div>
                </div>
            </Drawer>
            {showPreview && <CrudPreview entityType={entityType} show={showPreview} />}
        </div>
    );
});

CrudContainer.displayName = 'CrudContainer';

export default CrudContainer;
